import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import { a as EGDSButton } from '../paging-button/index-chunk.esm.js';

class EGDSExternalButton extends React.Component {
    static displayName = 'EGDSExternalButton';
    render() {
        const { props } = this;
        const cssClassNames = classNames(`${EGDSButton.baseClassName}-external`, props.className);
        return jsx(EGDSButton, { ...props, className: cssClassNames });
    }
}

class EGDSGoogleSigninButton extends React.Component {
    static displayName = 'EGDSGoogleSigninButton';
    render() {
        const { children, ...props } = this.props;
        const cssClassNames = classNames(`${EGDSButton.baseClassName}-google-signin`);
        return (jsx(EGDSButton, { ...props, className: cssClassNames, children: children || null }));
    }
}

class EGDSPrimaryAltButton extends React.Component {
    static displayName = 'EGDSPrimaryAltButton';
    render() {
        const { ...props } = this.props;
        const cssClassNames = classNames(props.className, `${EGDSButton.baseClassName}-primary-alt`);
        return jsx(EGDSButton, { ...props, className: cssClassNames });
    }
}

export { EGDSExternalButton as E, EGDSGoogleSigninButton as a, EGDSPrimaryAltButton as b };
//# sourceMappingURL=index-chunk.esm.js.map
